<template>
  <v-container>
    <h2 style="color:gray">Cài Đặt Học Sinh</h2>
    <v-divider class="my-3"></v-divider>
    <v-row class="py-3">
      <v-col cols="12">
        <v-checkbox
          hide-details
          v-model="policies"
          value="view-student-group"
          :label="'Cho phép ' + roleName + ' thiết lập học sinh'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- học sinh -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="view-student-list"
          :label="'Cho phép ' + roleName + ' xem danh sách học sinh'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="add-new-student"
          :label="'Cho phép ' + roleName + ' tạo mới học sinh'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="update-student-info"
          :label="'Cho phép ' + roleName + ' cập nhật thông tin học sinh'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="delete-student"
          :label="'Cho phép ' + roleName + ' xóa học sinh'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="update-student-status"
          :label="'Cho phép ' + roleName + ' chuyển trạng thái học sinh'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="update-student-class"
          :label="'Cho phép ' + roleName + ' chuyển lớp học sinh'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- Điểm danh -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12">
        <v-checkbox
          hide-details
          v-model="policies"
          value="view-attendance-item"
          :label="'Cho phép ' + roleName + ' truy cập mục chuyên cần'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="view-attendance-list"
          :label="'Cho phép ' + roleName + ' xem danh sách điểm danh'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="add-new-attendance"
          :label="'Cho phép ' + roleName + ' thêm điểm danh'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="update-attendance"
          :label="'Cho phép ' + roleName + ' sửa điểm danh'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- Chuyên cần -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="view-diligence-list"
          :label="'Cho phép ' + roleName + ' xem danh sách chuyên cần'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="add-new-diligence"
          :label="'Cho phép ' + roleName + ' thêm chuyên cần'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="update-diligence"
          :label="'Cho phép ' + roleName + ' sửa chuyên cần'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="delete-diligence"
          :label="'Cho phép ' + roleName + ' xóa chuyên cần'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- khen thưởng kỷ luật -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="view-violation-list"
          :label="'Cho phép ' + roleName + ' xem khen thưởng kỷ luật'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="add-new-violation"
          :label="'Cho phép ' + roleName + ' thêm khen thưởng kỷ luật'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="update-violation"
          :label="'Cho phép ' + roleName + ' sửa khen thưởng kỷ luật'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="delete-violation"
          :label="'Cho phép ' + roleName + ' xóa khen thưởng kỷ luật'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- báo nghỉ -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="absent-request"
          :label="'Cho phép ' + roleName + ' xem danh sách học sinh báo nghỉ'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <!-- sổ điểm -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="view-student-mark"
          :label="'Cho phép ' + roleName + ' xem sổ điểm học sinh'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mx-5" @click="resetPolicies()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import mixins from './helper/mixins'

export default {
  mixins: [mixins]
}
</script>
